import { Navigate, useSearchParams } from 'react-router-dom';
import { FoldersTable } from '@/modules/my-docs/components/FoldersTable.jsx';

// A docs uuid (a folder's, a file's).
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * My Documents, the root of the person's tree.
 *
 * Deep link: `/my-docs?folder=<uuid>&file=<uuid>` lands in that folder and
 * opens the file's viewer (the signing panel for a signed document, the
 * editor otherwise) — what another module of the install sends a person to.
 * The folder part is a redirect to the folder route; the file part rides
 * along as `?file=` and FoldersTable opens it once the listing is up
 * (`/my-docs?file=<uuid>` alone opens it at the root).
 */
export const MyDocs = () => {
  const [params] = useSearchParams();
  const folder = params.get('folder');
  const file = params.get('file');
  if (folder && UUID_RE.test(folder)) {
    return <Navigate to={`/files/${folder}${file ? `?file=${encodeURIComponent(file)}` : ''}`} replace />;
  }
  return <FoldersTable />;
};
